module.exports = __webpack_public_path__ + "img/home_img_08.05bc4e77.png";